<template>
    <div class="root h-full board-container">
        <slot></slot>
        
        <div class="tooltip-container large user-info-tooltip">
            <div class="connecter-part"></div>
            <div class="tooltip"></div>
        </div>

        <div @mousedown="mouseDown = true" @mousemove="mouseDown ? draggingBodyContent = true : draggingBodyContent = false" @mouseup="darggingTaskContent($event)">
            <VModal
                class="edit-task-modal"
                ref="edit-task"
                size="xl"
                @hideModal="$emit('closeModalEditTask')"
                @hiddenCancel="hiddenCancel"
            >
                <EditTask
                    :tags="tags"
                    :allEvents="events"
                    :boardOverviewFunc="boardOverviewFunc"
                    :board_id_from_task="board_id_from_task"
                    :draggingBodyContent="draggingBodyContent"
                    @hideModal="hideEditModal"
                    @toggleConflictSaving="toggleConflictSaving"
                    @hiddenCancel="hiddenCancel"
                    @tagsUpdate="$emit('tagsUpdate')"
                    @showUploadState="showUploadState"
                />
            </VModal>
            <VModal ref="save-changes-modal" class="save-changes-modal cant-hide" size="sm">
                <p class="text-center mb-3">Save or Cancel changes before leaving</p>
                <div class="btn-holder">
                    <VButton @clickHandler="saveOnOutsideClick" theme="orange" active>Save</VButton>
                    <VButton @clickHandler="dontSaveOnOutsideClick" theme="orange">Don't Save</VButton>
                </div>
            </VModal>
            <VModal ref="continue-editing-comment" class="continue-editing-comment cant-hide" size="sm">
                <p class="text-center mb-3">Continue editing comment or leave</p>
                <div class="btn-holder">
                    <VButton @clickHandler="continueMessage" theme="orange" active>Continue</VButton>
                    <VButton @clickHandler="leaveMessage" theme="orange">Leave</VButton>
                </div>
            </VModal>
        </div>

        <VModal ref="edit-list" :flexheight="true" size="sm">
            <form @submit.prevent="editList">
                <Textfield
                    :id="'editListTitle'"
                    v-model="list.title"
                    :placeholder="'List name'"
                />

                <div class="text-center edit-list-title">
                    <VButton @clickHandler="editList()" active>
                        Edit
                    </VButton>
                    <VButton @clickHandler="$refs['edit-list'].hideModal()">
                        Cancel
                    </VButton>
                </div>
            </form>
        </VModal>

        <ConfirmDelete id="confirm-delete-task" title="task" @delete="deleteTask()"/>

        <Flash ref="show"/>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import VModal from "@/components/atoms/VModal.vue";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import VButton from "@/components/atoms/VButton";
import EditTask from "@/components/molecules/EditTask.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import Flash from "@/components/Flash.vue";

export default {
    name: "BoardContainer",
    components: {
        VModal,
        ConfirmDelete,
        VButton,
        EditTask,
        Textfield,
        Flash
    },
    props: ['board_id_from_task', 'tags', 'events', 'list', 'edit_modal_toggle', 'cacheTimerRenewLock', 'from_task', 'board_id', "boardOverviewFunc", 'filterByTag'],
    data() {
        return {
            mouseDown: false,
            draggingBodyContent: false
        }
    },
    computed: {
        boards() {
            return this.$store.getters.boards
        },
        editableTask() {
            return this.$store.getters.editableTask
        },
        isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
		isCommenting() {
			return this.$store.getters.isCommenting
		},
    },
    methods: {
        toggleConflictSaving(mode) {
            if (mode == 'show') {
                this.$refs['conflict-saving'].$refs['conflict-saving'].showModal()
            } else {
                this.$refs['conflict-saving'].$refs['conflict-saving'].hideModal()
            }
        },
        async editList() {
            const data = {
                id: this.list.id,
                title: this.list.title,
            };

            try {
                const response = await api.post(`/list_edit`, data);

                if (response.status === 200) {
                    this.$store.dispatch('editActiveBoardList', {title: response.data.data.title, id: response.data.data.id})
                    this.filterByTag()
                    this.$refs['edit-list'].hideModal();
                    document.body.click()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e.response.data.msg)
                console.error(e);
            }
        },
        hideEditModal() {
            this.$refs['edit-task'].hideModal();
            this.$emit('closeModalEditTask');
        },
        darggingTaskContent(event) {
            const body = document.querySelector('.task-body-html')
            if (!this.draggingBodyContent) {
                this.mouseDown = false
                return
            }
            
            if (body && (event.target === body || body.contains(event.target))) {
                setTimeout(() => {
                    this.mouseDown = false
                    this.draggingBodyContent = false
                }, 100)
            }
        },
        hiddenCancel() {
            if (this.isTaskEditing) {
                this.$refs['save-changes-modal'].showModal()
            } else if (this.isCommenting) {
                this.$refs['continue-editing-comment'].showModal()
            }
        },
        saveOnOutsideClick() {
            this.$store.dispatch('setTaskEditing', false)
            this.$refs['edit-task'].$children[0].saveOnOutsideClick(this.$refs['edit-task'])
            this.$refs['save-changes-modal'].hideModal()
        },
        dontSaveOnOutsideClick() {
            this.$store.dispatch('setTaskEditing', false)
            this.$refs['edit-task'].$children[0].dontSaveOnOutsideClick(this.$refs['edit-task'])
            this.$refs['save-changes-modal'].hideModal()
        },
        continueMessage() {
            this.$refs['continue-editing-comment'].hideModal()
            document.querySelector('.texarea-comment textarea').focus()
        },
        leaveMessage() {
            this.$store.dispatch('setCommenting', false)
            this.$refs['edit-task'].hideModal()
            this.$refs['continue-editing-comment'].hideModal()
        },
        showUploadState(files, taskID) {
            console.log('showUploadState boardContainer')
            console.log(this.$parent)
            this.$parent?.showUploadState(files, taskID)
        }
    }
};
</script>

<style scoped lang="css">
.board-container {
    text-align: left;
    overflow-x: scroll;
    padding: 20px 20px;
    display: flex;
    /*height: 100vh;*/
}
.user-info-tooltip {
    display: none;
}
.user-info-tooltip .connecter-part {
    height: 40px;
    top: -30px;
    width: 25px;
    left: -3px;
    transform: translate(0);
    min-width: 15px;
    padding: 5px !important;
}

.edit-list-title {
    .btn {
        margin-right: 5px;
        width: 64px;
    }
}
</style>
